// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CoverMyMedsV1ClientGeneratedPriorAuthorizationProcessStatusRequestModel {
    'patient_last_name'?: string | null;
    'pa_status'?: string | null;
    'patient_identifier'?: string | null;
    'pa_key'?: string | null;
    'drug_name'?: string | null;
    'quantity'?: string | null;
    'days_supply'?: string | null;
    'pa_expiration_date'?: Moment | null;
    'appeal_of'?: string | null;
    'appeals'?: Array<string> | null;
    'is_outreach_exhausted'?: boolean | null;
    'external_pa_identifier'?: string | null;
    'isAccountDisplayId'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CoverMyMedsV1ClientGeneratedPriorAuthorizationProcessStatusRequestModel>> = [
        {
            "name":     "patient_last_name",
            "baseName": "patient_last_name",
            "type":     "string"
        },
        {
            "name":     "pa_status",
            "baseName": "pa_status",
            "type":     "string"
        },
        {
            "name":     "patient_identifier",
            "baseName": "patient_identifier",
            "type":     "string"
        },
        {
            "name":     "pa_key",
            "baseName": "pa_key",
            "type":     "string"
        },
        {
            "name":     "drug_name",
            "baseName": "drug_name",
            "type":     "string"
        },
        {
            "name":     "quantity",
            "baseName": "quantity",
            "type":     "string"
        },
        {
            "name":     "days_supply",
            "baseName": "days_supply",
            "type":     "string"
        },
        {
            "name":     "pa_expiration_date",
            "baseName": "pa_expiration_date",
            "type":     "Date"
        },
        {
            "name":     "appeal_of",
            "baseName": "appeal_of",
            "type":     "string"
        },
        {
            "name":     "appeals",
            "baseName": "appeals",
            "type":     "Array<string>"
        },
        {
            "name":     "is_outreach_exhausted",
            "baseName": "is_outreach_exhausted",
            "type":     "boolean"
        },
        {
            "name":     "external_pa_identifier",
            "baseName": "external_pa_identifier",
            "type":     "string"
        },
        {
            "name":     "isAccountDisplayId",
            "baseName": "isAccountDisplayId",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return CoverMyMedsV1ClientGeneratedPriorAuthorizationProcessStatusRequestModel.attributeTypeMap;
    }
}
